import { createSlice } from "@reduxjs/toolkit"

import initialState from "./initialState"
import reducers from "./reducers"

export const uiSlice = createSlice({
  name: "ui",
  initialState: initialState,
  reducers: {
    ...reducers,
    reset: () => initialState,
  },
})

// Export only the reducer actions to be ran outside of the context to thunks.
// In other words, using the dispatch(reducerName({...})).
// Remember, you can not await the dispatch of a reducer action.
export const {
  closeModal,
  clickCity,
  focusCity,
  pingCity,
  openCityModal,
  clearSelectedCity,
  startPickingOrigin,
  stopPickingOrigin,
  hoverCity,
  clearHover,
  startMovementFromCity,
  startMovementToCity,
  startColonizationFromCity,
  resetMovementNodes,
  cancelMovement,
  setMovementTroops,
  openMovementModal,
  startStrikeFromCity,
  clearStrike,
  setCityOrder,
  rememberCityRows,
  rememberFacings,
  spawnTourStarted,
  spawnTourEnded,
} = uiSlice.actions

// Reducer is used by the store to set the state of the user slice
export default uiSlice.reducer

// Export selectors and thunks to be able to be used from components easily
// in terms of the imports.
export * from "./selectors"

// Export the UI watcher to be used in the Game view
export { default as UIWatcher } from "./UIWatcher"
